import { render, staticRenderFns } from "./WaitBid.vue?vue&type=template&id=a77f9a02&scoped=true"
import script from "./WaitBid.vue?vue&type=script&lang=js"
export * from "./WaitBid.vue?vue&type=script&lang=js"
import style0 from "./WaitBid.vue?vue&type=style&index=0&id=a77f9a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f9a02",
  null
  
)

export default component.exports